<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-4 d-print-none d-flex align-items-center">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div
          [ngClass]="getRoleStatusClasses(role)"
          class="col-sm-12 col-md-4 d-flex align-items-start flex-column justify-content-center"
        >
          <h1 *ngIf="role">
            {{ (role.name ?? "") + "  (" + (role.code ?? "New Role") + ")" }}
          </h1>
          <span *ngIf="role">
            {{
              role.status == 1 && !role.color
                ? "Active"
                : role.status == 0
                  ? "Inactive"
                  : role.id < 0
                    ? "Pending Create"
                    : ""
            }}
          </span>
        </div>
        <div
          class="col-12 col-md-4 d-flex flex-column justify-content-center align-items-end"
        >
          <div
            class="d-flex flex-column justify-content-center align-items-end small"
          >
            <ng-container *ngIf="!role?.pendingRoles?.length">
              <span *ngIf="role?.createdByUser">
                Created by: <b>{{ role?.createdByUser?.name }}</b> on
                <span class="date">{{ role?.createdOn | date }}</span>
              </span>
              <span *ngIf="role?.updatedByUser">
                Modified by: <b>{{ role?.updatedByUser?.name }}</b> on
                <span class="date">{{ role?.updatedOn | date }}</span>
              </span>
              <span *ngIf="role?.approvedBy">
                Approved by: <b>{{ role?.approvedBy?.name }}</b> on
                <span class="date">{{ role?.approvedDate | date }}</span>
              </span>
            </ng-container>
            <ng-container *ngIf="role?.pendingRoles?.length">
              <span
                *ngIf="isPendingDeleteRole(role); else pendingModificationInfo"
                class="red"
              >
                Pending deletion submitted by:
                <b>{{ getPendingRoleSubmitterName(role) }}</b>
                on
                <span class="date">{{
                  role?.pendingRoles?.at(-1)?.createdOn | date
                }}</span>
              </span>
              <ng-template #pendingModificationInfo>
                <span>
                  Modified by:
                  <b>{{ getPendingRoleSubmitterName(role) }}</b>
                  on
                  <span class="date">{{
                    role?.pendingRoles?.at(-1)?.createdOn | date
                  }}</span>
                </span>
              </ng-template>
              <mat-slide-toggle
                class="toggle"
                [(ngModel)]="details.roleModified"
                [disabled]="details.modifying"
                *ngIf="details.showRoleModified && !isPendingDeleteRole(role)"
                (change)="details.onShowRoleModified()"
                >Show Modification</mat-slide-toggle
              >
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <!-- <span *ngIf="isExpanded || isShowing">Filter</span> -->
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="side.applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <app-roles-list
              #side
              (rowSelected)="selectedRow($event)"
              #list
            ></app-roles-list>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="side.createRole()"
          class="parent"
          *ngIf="hasPrivilege(privilegeEnum.RoleCatalogCreate)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content" [ngClass]="{}">
          <app-role-details
            [role]="role"
            (refreshRoles)="side.refreshRoles($event)"
            (restoreRole)="side.setOriginalRole($event)"
            (roleSelected)="this.role = $event; side.roleSelected($event)"
            #details
          ></app-role-details>
        </div>

        <div
          class="buttons d-print-none"
          id="sidenav-content-buttons"
          [ngClass]="{}"
        ></div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
